/* global BX24 */
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Table, Container, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// Медиа-запросы только для таблицы
// Медиа-запросы и стили для таблицы
const responsiveStyles = `
    @media (max-width: 1200px) {
        .table-responsive td, .table-responsive th {
            font-size: 12px;
            padding: 6px 8px;
        }
        .table-responsive {
            width: 100%;
            overflow-x: hidden;
        }
    }
    @media (max-width: 768px) {
        .table-responsive td, .table-responsive th {
            font-size: 10px;
            padding: 4px 6px;
        }
    }
    thead th {
        position: sticky;
        top: 0;
        background-color: #f8f9fa;
        z-index: 1;
    }
    /* Убираем затемнение для столбца Номенклатура (третий столбец) */
    .table-striped tbody tr:nth-child(even) td:nth-child(3) {
        background-color: inherit;
    }
`;  

const PriceListsSummary = () => {
    const [isBitrix, setIsBitrix] = useState(false)
    const alternatingRowStyle = {
        backgroundColor: "rgba(0, 0, 0, 0.05)", // Более тёмный цвет для нечётных строк
    }
    const styles = {
        container: { maxWidth: "100%", margin: "0 auto", padding: "0 15px", minHeight: "100vh", overflowX: "hidden" },
        tableWrapper: { 
            overflowX: isBitrix ? "hidden" : "auto", 
            marginBottom: "1rem",
            maxHeight: "1700px",
            overflowY: "auto",
            height: "1700px"
        },
        table: { 
            minWidth: isBitrix ? "100%" : "1600px",
            width: "100%", 
            tableLayout: isBitrix ? "fixed" : "auto"
        },
        th: { 
            whiteSpace: isBitrix ? "normal" : "nowrap",
            padding: isBitrix ? "6px 8px" : "8px 12px", 
            fontSize: isBitrix ? "12px" : "14px",
            position: "sticky",
            top: -1,
            backgroundColor: "#f8f9fa",
            zIndex: 1
        },
        td: { 
            whiteSpace: "normal",
            padding: isBitrix ? "6px 8px" : "8px 12px", 
            wordBreak: "break-word",
            fontSize: isBitrix ? "12px" : "14px"
        },
        priceTd: { textAlign: "center", verticalAlign: "middle", fontSize: "16px" },
        sourceColumn: { minWidth: isBitrix ? "40px" : "80px" },
        manufacturerColumn: { minWidth: isBitrix ? "50px" : "80px" },
        nomenclatureColumn: { minWidth: isBitrix ? "200px" : "400px" },
        categoryColumn: { minWidth: isBitrix ? "60px" : "130px" },
        productGroupColumn: { minWidth: isBitrix ? "60px" : "130px" },
        regionColumn: { minWidth: isBitrix ? "20px" : "30px" },
        priceColumn: { minWidth: isBitrix ? "30px" : "80px", textAlign: "center", verticalAlign: "middle" },
        dateColumn: { minWidth: isBitrix ? "50px" : "100px", textAlign: "center", verticalAlign: "middle" },
        descriptionColumn: { minWidth: isBitrix ? "30px" : "80px" },
        filterRow: { marginBottom: "1rem" },
        filterSelect: { width: "100%" },
        searchRow: { marginBottom: "1rem" },
        showMoreButton: { display: "block", margin: "0 auto", marginTop: "1rem" },
    };

    const [priceListsData, setPriceListsData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [displayedData, setDisplayedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [region, setRegion] = useState(null)
    
    const [categories, setCategories] = useState([]);
    const [filters, setFilters] = useState({
        source: "",
        category: "",
        manufacturer: "",
        product_group: "",
        region: region ? region : "",
    });
    const [inputValue, setInputValue] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const searchInputRef = useRef(null);
    const [dealId, setDealId] = useState(null)

    const toastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`${PATH_TO_BACKEND}/api/address_clientname/region`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ dealId }),
              });
              const data = await response.json();
              console.log(data)
              setFilters({
                source: "",
                category: "",
                manufacturer: "",
                product_group: "",
                region: data.region,
            })
        }

        fetchData()
    }, [dealId])

    const translitMap = {
        q: "й", w: "ц", e: "у", r: "к", t: "е", y: "н", u: "г", i: "ш", o: "щ", p: "з", "[": "х", "]": "ъ",
        a: "ф", s: "ы", d: "в", f: "а", g: "п", h: "р", j: "о", k: "л", l: "д", ";": "ж", "'": "э",
        z: "я", x: "ч", c: "с", v: "м", b: "и", n: "т", m: "ь", ",": "б", ".": "ю", "/": ".",
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [loading]);

    const transliterate = (input) => {
        return input
            .split("")
            .map((char) => translitMap[char.toLowerCase()] || char)
            .join("");
    };

    const normalizeOsbText = (text) => {
        return text
            ? text
                .toLowerCase()
                .replace(/осб|осп|osb/g, "osb")
                .replace(/пеноплекс|пеноплэкс/g, "пеноплэкс")
                .replace(/[()]/g, "")
                .replace(/,/g, ".")
                .replace(/\s+/g, " ")
                .trim()
            : "";
    };

    let debounceTimeout;
    const debouncedSetSearchValue = useCallback((value) => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            setSearchValue(value);
        }, 500);
    }, []);

    useEffect(() => {
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, []);

    useEffect(() => {
        try {
          BX24.init(() => {
            setIsBitrix(true)
            const placementInfo = BX24.placement?.info?.();
            const bxDealId = placementInfo.options.ID.toString();
            console.log("✅ ID сделки:", bxDealId);
            setDealId(bxDealId)

            BX24.resizeWindow(window.innerWidth, 1050, () => {
                console.log("Высота окна приложения увеличена до 750px");
            });
          })
        } catch (error) {
          setIsBitrix(false)
        }
      }, [])

    useEffect(() => {
        const fetchPriceLists = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/adminka/all-price-lists`, {
                    withCredentials: true,
                });
                if (response.data.success && response.data.data) {
                    setPriceListsData(response.data.data);
                } else {
                    throw new Error("Не удалось загрузить данные прайс-листов");
                }
            } catch (error) {
                console.error("Ошибка при загрузке прайс-листов:", error);
                toast.error(`Ошибка при загрузке прайс-листов: ${error.message}`, toastOptions);
            } finally {
                setLoading(false);
            }
        };
    
        fetchPriceLists();
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            if (filters.product_group) {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/adminka/unique-categories-by-calculator?calculator=${filters.product_group}`,
                    );
                    if (response.data.success) {
                        setCategories(response.data.data);
                    } else {
                        setCategories([]);
                        toast.error("Не удалось загрузить категории", toastOptions);
                    }
                } catch (error) {
                    console.error("Ошибка при загрузке категорий:", error);
                    toast.error(`Ошибка: ${error.message}`, toastOptions);
                    setCategories([]);
                }
            } else {
                setCategories([]);
            }
        };

        fetchCategories();
    }, [filters.product_group]);

    const uniqueRegions = useMemo(() => {
        return [...new Set(priceListsData.map((item) => item.region))].filter(Boolean).sort();
    }, [priceListsData]);

    const uniqueSources = useMemo(() => {
        return [...new Set(priceListsData.map((item) => item.source))].sort();
    }, [priceListsData]);

    const uniqueManufacturers = useMemo(() => {
        let filtered = priceListsData;
        if (filters.source) filtered = filtered.filter((item) => item.source === filters.source);
        if (filters.category) filtered = filtered.filter((item) => item.category === filters.category);
        if (filters.product_group) filtered = filtered.filter((item) => item.product_group === filters.product_group);
        if (filters.region) filtered = filtered.filter((item) => item.region === filters.region);
        return [...new Set(filtered.map((item) => item.manufacturer).filter(Boolean))].sort();
    }, [priceListsData, filters.source, filters.category, filters.product_group, filters.region]);

    const uniqueProductGroups = useMemo(() => {
        let filtered = priceListsData;
        if (filters.source) filtered = filtered.filter((item) => item.source === filters.source);
        if (filters.region) filtered = filtered.filter((item) => item.region === filters.region);
        return [...new Set(filtered.map((item) => item.product_group).filter(Boolean))].sort();
    }, [priceListsData, filters.source, filters.region]);

    // Вычисляем минимальную и максимальную цену для столбца "Цена (наличные)"
    const priceRange = useMemo(() => {
        const prices = filteredData
            .map((item) => Number(item.price_cash?.replace(/\s/g, "")))
            .filter((price) => !isNaN(price));
        return {
            min: prices.length > 0 ? Math.min(...prices) : 0,
            max: prices.length > 0 ? Math.max(...prices) : 0,
        };
    }, [filteredData]);

    const isFilteringActive = useMemo(() => {
        return (
            filters.source ||
            filters.category ||
            filters.manufacturer ||
            filters.product_group ||
            filters.region ||
            searchValue.trim()
        );
    }, [filters, searchValue]);

    // Функция для генерации цвета на основе строки
    // Функция для генерации цвета для номенклатуры
    const colorCache = new Map();
    const stringToColor = (str) => {
    if (!isFilteringActive || !str || str === "-") return "#ffffff";

    // Проверяем кэш
    if (colorCache.has(str)) return colorCache.get(str);

    // Улучшенная хэш-функция
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) + hash + str.charCodeAt(i); // Улучшенное хэширование
        hash = hash & hash; // Ограничение для предотвращения переполнения
    }

    // Генерация цвета
    const hue = Math.abs(hash % 360); // Оттенок от 0 до 359
    const saturation = 40 + (Math.abs(hash) % 40); // Насыщенность от 40% до 80%
    const lightness = 60 + (Math.abs(hash) % 30); // Светлота от 60% до 90%
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    // Сохраняем в кэш
    colorCache.set(str, color);
    return color;
    };

    // Функция для вычисления цвета на основе цены
    const getPriceBackgroundColor = (price) => {
        if (!isFilteringActive || isNaN(Number(price?.replace(/\s/g, ""))))
            return "#ffffff"; // Белый, если фильтры не активны или цена нечисловая

        const value = Number(price.replace(/\s/g, ""));
        const { min, max } = priceRange;

        if (min === max) return "#ffffff"; // Если все цены одинаковы

        const normalized = (value - min) / (max - min);

        let hue, saturation, lightness;
        if (normalized <= 0.5) {
            hue = 120; // Зелёный
            saturation = 60;
            lightness = 35 + (normalized / 0.5) * (100 - 35);
        } else {
            hue = 0; // Красный
            saturation = 100;
            lightness = 100 - ((normalized - 0.5) / 0.5) * (100 - 50);
        }
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };


    const filteredResults = useMemo(() => {
        console.time("filteredResults");
        const normalizedInput = normalizeOsbText(searchValue.trim());
        const transliteratedInput = transliterate(normalizedInput);
        const searchWords = normalizedInput.split(" ").filter(Boolean);
        const transliteratedSearchWords = transliteratedInput.split(" ").filter(Boolean);

        const results = priceListsData
            .filter((item) => {
                const matchesSource = !filters.source || item.source === filters.source;
                const matchesCategory = !filters.category || item.category === filters.category;
                const matchesManufacturer = !filters.manufacturer || item.manufacturer === filters.manufacturer;
                const matchesProductGroup = !filters.product_group || item.product_group === filters.product_group;
                const matchesRegion = !filters.region || item.region === filters.region;

                if (!normalizedInput) {
                    return matchesSource && matchesCategory && matchesManufacturer && matchesProductGroup && matchesRegion;
                }

                const name = normalizeOsbText(item.product_calculator_name || "");
                const manufacturer = normalizeOsbText(item.manufacturer || "");
                const nameWords = name.split(" ");
                const manufacturerWords = manufacturer.split(" ");

                const matchesOriginal = searchWords.every((searchWord) =>
                    nameWords.some((word) => word.includes(searchWord)) ||
                    manufacturerWords.some((word) => word.includes(searchWord))
                );
                const matchesTransliterated = transliteratedSearchWords.every((searchWord) =>
                    nameWords.some((word) => word.includes(searchWord)) ||
                    manufacturerWords.some((word) => word.includes(searchWord))
                );

                return (
                    matchesSource &&
                    matchesCategory &&
                    matchesManufacturer &&
                    matchesProductGroup &&
                    matchesRegion &&
                    (matchesOriginal || matchesTransliterated)
                );
            })
            .sort((a, b) => {
                const queryLower = normalizedInput.toLowerCase();
                const aName = normalizeOsbText(a.product_calculator_name || "").toLowerCase();
                const bName = normalizeOsbText(b.product_calculator_name || "").toLowerCase();
                if (aName === queryLower && bName !== queryLower) return -1;
                if (bName === queryLower && aName !== queryLower) return 1;
                const [dayA, monthA, yearA] = a.price_update_date.split(".").map(Number);
                const [dayB, monthB, yearB] = b.price_update_date.split(".").map(Number);
                const dateA = new Date(2000 + yearA, monthA - 1, dayA);
                const dateB = new Date(2000 + yearB, monthB - 1, dayB);
                return dateB - dateA;
            });
        console.timeEnd("filteredResults");
        return results;
    }, [filters, searchValue, priceListsData]);

    useEffect(() => {
        setFilteredData(filteredResults);
        setDisplayedData(filteredResults);
    }, [filteredResults]);

    const handleSearchChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        if (!newValue.trim()) {
            setSearchValue("");
        } else {
            debouncedSetSearchValue(newValue);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => {
            let newFilters = { ...prev, [name]: value };

            if (name === "source" || name === "region") {
                const filteredBySourceAndRegion = priceListsData.filter((item) =>
                    (!newFilters.source || item.source === newFilters.source) &&
                    (!newFilters.region || item.region === newFilters.region)
                );
                const availableProductGroups = new Set(filteredBySourceAndRegion.map((item) => item.product_group).filter(Boolean));
                const availableManufacturers = new Set(filteredBySourceAndRegion.map((item) => item.manufacturer).filter(Boolean));

                if (prev.product_group && !availableProductGroups.has(prev.product_group)) {
                    newFilters.product_group = "";
                    newFilters.category = "";
                }
                if (prev.manufacturer && !availableManufacturers.has(prev.manufacturer)) {
                    newFilters.manufacturer = "";
                }
            }

            if (name === "product_group") {
                newFilters.category = "";
                const filtered = priceListsData.filter((item) =>
                    (prev.source ? item.source === prev.source : true) &&
                    (prev.region ? item.region === prev.region : true)
                );
                const availableManufacturers = new Set(filtered.map((item) => item.manufacturer).filter(Boolean));
                if (prev.manufacturer && !availableManufacturers.has(prev.manufacturer)) {
                    newFilters.manufacturer = "";
                }
            }

            if (name === "category") {
                let filtered = priceListsData;
                if (prev.source) filtered = filtered.filter((item) => item.source === prev.source);
                if (prev.region) filtered = filtered.filter((item) => item.region === prev.region);
                if (prev.product_group) filtered = filtered.filter((item) => item.product_group === prev.product_group);
                const availableManufacturers = new Set(filtered.map((item) => item.manufacturer).filter(Boolean));
                if (prev.manufacturer && !availableManufacturers.has(prev.manufacturer)) {
                    newFilters.manufacturer = "";
                }
            }

            return newFilters;
        });
    };

    const calculateDaysSince = (dateString) => {
        if (!dateString || dateString === "-") return "-";
    
        try {
            // Предполагаем формат DD.MM.YY
            const [day, month, year] = dateString.split(".").map(Number);
            // Преобразуем двухзначный год в полный (например, 25 -> 2025)
            const fullYear = year < 100 ? 2000 + year : year;
            const priceDate = new Date(fullYear, month - 1, day);
            const today = new Date();
    
            // Устанавливаем время на 00:00 для корректного сравнения
            today.setHours(0, 0, 0, 0);
            priceDate.setHours(0, 0, 0, 0);
    
            // Вычисляем разницу в миллисекундах и переводим в дни
            const diffTime = today - priceDate;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
            // Возвращаем 0 для сегодняшней даты, число дней для прошлых дат, "-" для будущих или некорректных дат
            return diffDays === 0 ? 1 : diffDays >= 0 ? diffDays : "-";
        } catch (error) {
            console.error("Ошибка при вычислении разницы дат:", error);
            return "-";
        }
    };

    const resetFilters = () => {
        setFilters({ source: "", category: "", manufacturer: "", product_group: "", region: "" });
        setInputValue("");
        setSearchValue("");
        setCategories([]);
    };

    return (
        <div style={styles.container} className="my-5">
            <style>{responsiveStyles}</style>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Сводная таблица прайс-листов</h1>
                <Link to="/">
                    <Button variant="secondary">Вернуться на главную</Button>
                </Link>
            </div>
            {loading ? (
                <div>Загрузка данных...</div>
            ) : priceListsData.length === 0 ? (
                <div>Данные прайс-листов отсутствуют.</div>
            ) : (
                <>
                    <Row style={styles.searchRow}>
                        <Col md={6}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Поиск по производителю или номенклатуре..."
                                    value={inputValue}
                                    onChange={handleSearchChange}
                                    ref={searchInputRef}
                                />
                                {inputValue && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => {
                                            setInputValue("");
                                            setSearchValue("");
                                        }}
                                        style={{ marginLeft: "20px" }}
                                    >
                                        Очистить
                                    </Button>
                                )}
                            </InputGroup>
                        </Col>
                    </Row>

                    <Row style={styles.filterRow}>
                        <Col md={2}>
                            <Form.Group controlId="productGroupFilter">
                                <Form.Label>Товарная группа</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="product_group"
                                    value={filters.product_group}
                                    onChange={handleFilterChange}
                                    style={styles.filterSelect}
                                >
                                    <option value="">Все</option>
                                    {uniqueProductGroups.map((product_group, index) => (
                                        <option key={index} value={product_group}>
                                            {product_group}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group controlId="categoryFilter">
                                <Form.Label>Категория</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="category"
                                    value={filters.category}
                                    onChange={handleFilterChange}
                                    style={styles.filterSelect}
                                    disabled={!filters.product_group}
                                >
                                    <option value="">Все</option>
                                    {categories.map((category, index) => (
                                        <option key={index} value={category}>
                                            {category}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group controlId="manufacturerFilter">
                                <Form.Label>Производитель</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="manufacturer"
                                    value={filters.manufacturer}
                                    onChange={handleFilterChange}
                                    style={styles.filterSelect}
                                >
                                    <option value="">Все</option>
                                    {uniqueManufacturers.map((manufacturer, index) => (
                                        <option key={index} value={manufacturer}>
                                            {manufacturer}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group controlId="sourceFilter">
                                <Form.Label>Источник</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="source"
                                    value={filters.source}
                                    onChange={handleFilterChange}
                                    style={styles.filterSelect}
                                >
                                    <option value="">Все</option>
                                    {uniqueSources.map((source, index) => (
                                        <option key={index} value={source}>
                                            {source}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group controlId="regionFilter">
                                <Form.Label>Регион</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="region"
                                    value={filters.region}
                                    onChange={handleFilterChange}
                                    style={styles.filterSelect}
                                >
                                    <option value="">Все</option>
                                    {uniqueRegions.map((region, index) => (
                                        <option key={index} value={region}>
                                            {region}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2} className="d-flex align-items-end mt-2">
                            <Button variant="outline-secondary" onClick={resetFilters}>
                                Сбросить фильтры
                            </Button>
                        </Col>
                    </Row>

                    <div style={styles.tableWrapper} className="table-responsive">
                        <Table bordered hover style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={{ ...styles.th, ...styles.sourceColumn }}>Источник</th>
                                    <th style={{ ...styles.th, ...styles.manufacturerColumn }}>Поставщик</th>
                                    <th style={{ ...styles.th, ...styles.regionColumn }}>Регион</th>
                                    <th style={{ ...styles.th, ...styles.nomenclatureColumn, width: "50%" }}>Номенклатура</th>
                                    <th style={{ ...styles.th, ...styles.priceColumn }}>Цена (наличные)</th>
                                    <th style={{ ...styles.th, ...styles.priceColumn }}>Цена (безнал)</th>
                                    <th style={{ ...styles.th, ...styles.dateColumn }}>Сколько дней цене</th>
                                    <th style={{ ...styles.th, ...styles.descriptionColumn }}>Описание</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedData.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ ...styles.td, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>{item.source || "-"}</td>
                                        <td style={{ ...styles.td, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>{item.manufacturer || "-"}</td>
                                        <td style={{ ...styles.td, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>{item.region || "-"}</td>
                                        <td style={{ ...styles.td, backgroundColor: stringToColor(item.product_calculator_name) }}>
                                            {item.product_calculator_name || "-"}
                                        </td>
                                        <td style={{ ...styles.td, ...styles.priceTd, backgroundColor: getPriceBackgroundColor(item.price_cash) }}>
                                            {isNaN(Number(item.price_cash?.replace(/\s/g, "")))
                                                ? "-"
                                                : Number(item.price_cash.replace(/\s/g, "")).toLocaleString("ru-RU")}
                                        </td>
                                        <td style={{ ...styles.td, ...styles.priceTd, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>
                                            {isNaN(Number(item.price_non_cash?.replace(/\s/g, "")))
                                                ? "-"
                                                : Number(item.price_non_cash.replace(/\s/g, "")).toLocaleString("ru-RU")}
                                        </td>
                                        <td style={{ ...styles.td, ...styles.priceTd, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>{calculateDaysSince(item.price_update_date)}</td>
                                        <td style={{ ...styles.td, ...(index % 2 === 0 ? alternatingRowStyle : {}) }}>{item.description || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </>
            )}
        </div>
    );
};

export default PriceListsSummary;